import React from "react";

import { Button } from "../../Button";
import { Ellipsis } from "../../Elipsis";
import { Portal } from "../../Portal";
import { StepSelector } from "../../StepSelector";
import { TutorialPortal } from "../../TutorialPortal";

export const PostSessionSurveyTutorialHoc = ({
  className,
  currentStep,
  onSecondarySubmit,
  setCurrentStep,
  ...props
}) => {
  const steps = [
    {
      arrowPosition: null,
      onSecondarySubmit: onSecondarySubmit,
      primaryButtonComponent: (
        <Button
          className="apti-TutorialPortal--submit-btn"
          onClick={() => setCurrentStep(currentStep + 1)}
        >
          Get Started
        </Button>
      ),
      primaryButtonComponentMobile: (
        <Button
          className="apti-TutorialPortal--submit-btn--mobile"
          onClick={() => setCurrentStep(currentStep + 1)}
        >
          Get Started
        </Button>
      ),
      secondaryButtonText: "Skip",
      secondaryButtonTextMobile: "Skip",
      subText:
        "Ready to rate your session? Before you do, click Get Started to learn about what’s changed.",
      title: "We’ve updated our session rating!",
    },
    {
      arrowPosition: "left-top",
      onSecondarySubmit: onSecondarySubmit,
      primaryButtonComponent: (
        <StepSelector
          className="pss-tutorial-ss"
          currentStep={1}
          onRightClick={() => setCurrentStep(currentStep + 1)}
          totalSteps={3}
        />
      ),
      primaryButtonComponentMobile: (
        <div className="mobile-container">
          <Button
            className="apti-TutorialPortal--submit-btn--mobile"
            onClick={() => setCurrentStep(currentStep + 1)}
          >
            Continue
          </Button>
          <Ellipsis leftDisabled={true} />
        </div>
      ),
      secondaryButtonText: "Skip",
      secondaryButtonTextMobile: "Skip",
      subText:
        "Our new questions help us learn more about the care you’re receiving. We’ll check in after each session to make sure you’re feeling supported.",
      title: "Tell us how you’re feeling",
    },
    {
      arrowPosition: "top-left",
      mobileSubText:
        "We’ve given you more options! Slide each box to a point on the scale based on how you’re feeling. Once selected, the bar will turn purple.",
      onSecondarySubmit: onSecondarySubmit,
      primaryButtonComponent: (
        <StepSelector
          className="pss-tutorial-ss"
          currentStep={2}
          onLeftClick={() => setCurrentStep(currentStep - 1)}
          onRightClick={() => setCurrentStep(currentStep + 1)}
          totalSteps={3}
        />
      ),
      primaryButtonComponentMobile: (
        <div className="mobile-container">
          <Button
            className="apti-TutorialPortal--submit-btn--mobile"
            onClick={() => setCurrentStep(currentStep + 1)}
          >
            Continue
          </Button>
          <Ellipsis centerDisabled={true} />
        </div>
      ),
      secondaryButtonText: "Skip",
      secondaryButtonTextMobile: "Skip",
      subText:
        "We’ve given you more options! Select a box that best indicates how you feel. Once selected, the box will turn purple.",
      title: "Make a selection",
    },
    {
      arrowPosition: "top-center",
      onSecondarySubmit: onSecondarySubmit,
      primaryButtonComponent: (
        <StepSelector
          className="pss-tutorial-ss"
          currentStep={3}
          onLeftClick={() => setCurrentStep(currentStep - 1)}
          totalSteps={3}
        />
      ),
      primaryButtonComponentMobile: (
        <div className="mobile-container">
          <Button className="apti-TutorialPortal--submit-btn--mobile" onClick={onSecondarySubmit}>
            Close
          </Button>
          <Ellipsis rightDisabled={true} />
        </div>
      ),
      secondaryButtonText: "Close",
      secondaryButtonTextMobile: null,
      subText: "All done? Once you’ve answered each question, click submit to share your feedback.",
      title: "Submit your response",
    },
  ];

  return (
    <>
      {currentStep < 3 && (
        <Portal>
          <div className="overlay" />
        </Portal>
      )}
      <TutorialPortal
        arrowPosition={steps[currentStep].arrowPosition}
        className={className}
        mobileSubText={steps[currentStep].mobileSubText}
        onSecondarySubmit={steps[currentStep].onSecondarySubmit}
        secondaryButtonText={steps[currentStep].secondaryButtonText}
        secondaryButtonTextMobile={steps[currentStep].secondaryButtonTextMobile}
        subText={steps[currentStep].subText}
        title={steps[currentStep].title}
      >
        {steps[currentStep].primaryButtonComponent}
        {steps[currentStep].primaryButtonComponentMobile}
      </TutorialPortal>
    </>
  );
};
